import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { IDashExtServerSettings } from '../../../../types/IEditableServerSettings';

export interface IGetExtensionsServerSettingsParams {
}

export type IGetExtensionsServerSettingsResult = IResult & IDashExtServerSettings;

export class GetExtensionsServerSettingsRequest extends Request<IGetExtensionsServerSettingsParams, IGetExtensionsServerSettingsResult> {
  constructor(params: IGetExtensionsServerSettingsParams) {
    super('getExtensionsServerSettings', params);
  }
}
